import { cn } from '@/app/utils';

interface FeatureTagProps {
  text?: string;
  className?: string;
}

export const FeatureTag = ({ text = 'New', className }: FeatureTagProps) => {
  return (
    <div className={cn('rounded-[3px] bg-[#5765F2] px-1 font-medium text-[8px] text-white leading-[1.4]', className)}>
      {text}
    </div>
  );
};
